import { render, staticRenderFns } from "./ListBlocksPage.vue?vue&type=template&id=26d87261&scoped=true&"
import script from "./ListBlocksPage.vue?vue&type=script&lang=ts&"
export * from "./ListBlocksPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d87261",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
